import { useToast } from 'primevue/usetoast';
import { ref } from 'vue';

import { useClientSaver } from '../composables/useClientSaver';

import { useClientsStore } from '../store/clients';

import { clientSchema } from '../utils/schemas';

export function useClientFileHandler() {
  const toast = useToast();

  const clientStore = useClientsStore();

  const { addClientHandler, editClientHandler } = useClientSaver();

  const isLoading = ref(false);

  async function addClientFromFile(data: object) {
    try {
      isLoading.value = true;

      const client = clientSchema.parse(data);

      if (clientStore.getClientByUuid(client.uuid)) {
        await editClientHandler(client);
        return;
      }

      await addClientHandler(client);
    } catch (error) {
      console.error(error);

      toast.add({
        severity: 'error',
        summary: 'Wystąpił błąd podczas zapisywania klienta',
        life: 3000,
      });
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isLoading,
    addClientFromFile,
  };
}
